// Ant Design reads Descriptions.Item props from its direct children, so the
// shared layout must be spread onto the actual item in each detail surface.
export function metadataEntityDescriptionProps(entry) {
    return {
        label: entry.standard?.label || entry.custom?.name,
        labelStyle: {width: "28%", maxWidth: 180, minWidth: 120, whiteSpace: "normal", overflowWrap: "anywhere", verticalAlign: "top"},
        contentStyle: {minWidth: 0, whiteSpace: "normal", overflowWrap: "anywhere"}
    };
}
